import React from 'react'

import './index.scss'
const NoConfig = ({imgSrc,txt,stylecof,txtc}) => {
    return (
        <div className="no-config__box">
            <img style={{...stylecof}} src={imgSrc} alt="" />
            <p style={{color:txtc}}>{txt}</p>
        </div>
    )
}
export default NoConfig